export { default } from "./Assignment";
